import { io } from 'socket.io-client';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Create socket connection
const socket = io(BACKEND_URL, {
  path: '/api/socket.io/',
  transports: ['websocket', 'polling'],
  auth: {
    tenantId: 'default'
  },
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity,
  autoConnect: true,
});

socket.on('connect', () => {
  console.log('[NEXUS] Socket connected:', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('[NEXUS] Socket disconnected:', reason);
});

socket.on('connect_error', (error) => {
  console.error('[NEXUS] Socket connection error:', error.message);
});

export default socket;
